import { RoutePage } from './../../app-routes.enum';
import { inject, Injectable } from "@angular/core";
import { from, Observable, of } from "rxjs";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  UrlTree,
} from "@angular/router";
import {
  MSAL_GUARD_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalGuardConfiguration,
  MsalService,
} from "@azure/msal-angular";
import { NetworkStatusService } from "../../_services/network-status.service";

const PUBLIC_ROUTES = [RoutePage.CancelLogin].map(route => `/${route}`);

@Injectable({ providedIn: 'root' })
export class OffineAccessGuard
  extends MsalGuard
  implements CanActivate, CanActivateChild
{
  _msalService = inject(MsalService, { optional: true });

  _networkStatusService = inject(NetworkStatusService, { optional: true });

  _msalGuardConfig = inject<MsalGuardConfiguration>(MSAL_GUARD_CONFIG, {
    optional: true,
  });

  _msalBroadcastService = inject(MsalBroadcastService, { optional: true });

  _router = inject(Router, { optional: true });

  _location = inject(Location, { optional: true });

  debug(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    // Placeholder function for debugging navigation events
  }

  public canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.handleActivation(() => super.canActivate(next, state), next, state);
  }

  public canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.handleActivation(() => super.canActivateChild(next, state), next, state);
  }

  private handleActivation(
    activationHandler: () => Observable<boolean | UrlTree>,
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    this.debug(next, state);

    if (this.isPublicRoute) {
      return of(true);
    }

    if (this._networkStatusService.isOnline) {
      return activationHandler();
    }

    return of(true);
  }

  private get isPublicRoute() {
    return PUBLIC_ROUTES.includes(document.location.pathname);
  }

}
